/* eslint-disable jsx-a11y/accessible-emoji */
/* eslint-disable react/prop-types */
// import PropTypes from "prop-types";

import React, { useContext } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { AppContext } from "~context/AppContext";
import { DocumentContext } from "~context/DocumentContext";

const Notification = () => {
  const { notificationActive, setNotificationActive } = useContext(AppContext);

  const { device } = useContext(DocumentContext);

  const { allDataYaml } = useStaticQuery(graphql`
    query Notification {
      allDataYaml {
        edges {
          node {
            notification {
              notificationBackground
              notificationFont
              notificationText
            }
          }
        }
      }
    }
  `);

  let notification;

  if (allDataYaml?.edges?.[0]?.node) {
    ({ notification } = allDataYaml.edges[0].node);
  }

  const {
    notificationBackground,
    notificationFont,
    notificationText
  } = notification;

  //

  let font = `b1`;
  let padding = ``;

  switch (device) {
    case `mobile`:
      padding = `px-2`;
      font = `caption`;
      break;
    case `tablet`:
      padding = `px-24`;
      font = `b2`;
      break;
    default:
      break;
  }

  return (
    <>
      {notificationActive && notificationText && (
        <div
          className={`w-full h-16 md:h-12 fixed top-0 right-0 left-0 z-40 ${padding} bg-${notificationBackground} text-${notificationFont}`}
        >
          <button
            type="button"
            onClick={() => setNotificationActive(false)}
            className="w-full h-full relative block"
          >
            <p className={`${font} text-center`}>{notificationText}</p>
          </button>
        </div>
      )}
    </>
  );
};

export default Notification;
